const formatDate = (date, fmt) => {
    date = new Date(date);
    let m = date.getMonth() + 1;
    let d = date.getDate();
    let y = date.getFullYear();

    if (fmt) {
        let lookup = [
            'January',
            'February',
            'March',
            'April',
            'May',
            'June',
            'July',
            'August',
            'September',
            'October',
            'November',
            'December'
        ];
        if (fmt === 'long') {
            return `${lookup[m - 1]} ${d}, ${y}`;
        } else {
            return `${lookup[m - 1].substr(0, 3)} ${d}, ${y}`;
        }
    } else {
        return `${m}/${d}/${y}`;
    }
};

export { formatDate };
